export default Object.freeze({
  Educativo: 1,
  Terapia: 2,
});
